import React, { useEffect } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate } from 'react-router-dom';
import { ArrowForward, ArrowBack } from '@mui/icons-material';
import Header from '../components/Header';
import { theme } from '../Template';
import ServiceCard from '../components/ServiceCard';
import CourseCard from '../components/CourseCard';
import useCategoryList from '../../shared/logic/useCategoryList';
import { useCompanyData } from '../../shared/contexts/DataContext';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { categoryImage } from '../../shared/logic/imagesFns';
import {SectionTitle} from '../components/SectionTitle';
import CustomBreadCrumbs from '../components/CustomBreadcrumbs';
import CustomButton from '../components/CustomButton';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import GetImageDimensions from '../../shared/logic/getImgDimensions';
import { createMarkup, extractContent } from '../../shared/logic/Utils';
import { textVariant, textClasses } from '../../shared/config';

const useStyles = makeStyles(() => ({
  aboutImg:{
    boxShadow: '0px 0px 30px rgb(209,209,209)',
    "-webkit-box-shadow": '0px 0px 30px rgb(209,209,209)',
    "-moz-box-shadow": '0px 0px 30px rgb(209,209,209)'
  },

  tp:{
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    fontFamily:'inherit'
  },
}));

const CategoriesList = () => {
  const { data } = useCompanyData();
  const { services, courses, categoryName, categoryCover, description } = useCategoryList();

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[])

  return (
    <div>
      <ServicesHeader
        image={categoryImage(categoryCover,data)}
        data={data}
        categoryName={categoryName}
      />

      {categoryName && categoryCover ?
      <About 
        name={categoryName}
        image={categoryCover}
        description={description}
        data={data}
      />
      : null}

      {services?.length ?
        <>
          <Box width="90%" margin="auto">
            <SectionTitle>Services</SectionTitle>
          </Box>
          <ServicesList categories={services} data={data} />
        </>
      : null}
      {courses?.length ?
        <>
          <Box width="90%" margin="auto">
            <SectionTitle>Courses</SectionTitle>
          </Box>
          <ServicesList categories={courses} data={data} course={true} />
        </>
      :
      null}
    </div>
  );
};

const About = ({ name, image, description, data }) => {
  const [imageDimensions, setImageDimensions] = React.useState({});
  const matches = useMediaQuery(theme.breakpoints.up('lg'));
  const navigate = useNavigate();
  const classes = useStyles();
  const [showLess, setShowLess] = React.useState(true);
  const textLength = 800;
  const desc = description || '';
  const { buttonColor, buttonFontColor, t, isRTL } = data || {};

  React.useEffect(() => {
    GetImageDimensions(setImageDimensions, image);
  }, [image]);

  const extractedDesc = extractContent(desc);
  return (
    <Box
      py={5}
      my={8}
      display="flex"
      flexDirection={matches ? 'row' : 'column-reverse'}
      alignItems="center"
      justifyContent="center"
      width="90%"
      m="auto"
      position="relative"
    >
      {/* <BGSectionTitle justify="unset" image={imgAbout} left={0} top="-20px" / */}

      <Box
        width="auto"
        maxWidth="530px"
        height="auto"
        maxHeight="438px"
        overflow="hidden"
        borderRadius="15px"
        className={classes.aboutImg}
      >
        <ImgLazyLoad>
          <img
            style={{
              width:"100%",
              maxWidth: "530px",
              height:"auto",
              maxHeight: "438px",
              borderRadius:"15px",
              ...(imageDimensions?.height > 1280 ? {objectFit:'cover'} : {})
            }}
            src={image}
            alt={name || 'category'}
          />
        </ImgLazyLoad>
      </Box>
      <Box
        mb={matches ? 0 : 4}
        width={matches ? 'calc(100% - 590px)' : '100%'}
        minWidth="300px"
        style={{margin:'0px 30px'}}
      >
        <Box
          display={matches ? 'block' : 'flex'}
          flexDirection="column"
          alignItems="center"
        >
          <SectionTitle>{name}</SectionTitle>
        </Box>

        <Box pb={3} textAlign={isRTL === 'ar' ? 'right' : matches ? 'left' : 'center'}>
          <Typography variant="body1" style={{ opacity: '0.8' }} dangerouslySetInnerHTML={createMarkup(desc)}></Typography>
        </Box>

        {/* {!extractedDesc || extractedDesc && extractedDesc.length < textLength ?
        null :
        <Box textAlign={matches ? 'left' : 'center'}>
          <CustomButton
            style={{backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}}
            onClick={showLess ? ()=> setShowLess(false) : ()=> setShowLess(true)}
            endIcon={
              isRTL === 'en' ? (
                <ArrowForward
                  style={{ fontSize: '1.2rem', margin: '0 0.2em' }}
                />
              ) : (
                <ArrowBack
                  style={{ fontSize: '1.2rem', margin: '0 0.2em' }}
                />
              )
            }
          >
            {showLess ? t && t('companyPage.readMore') : t && t('companyPage.showless')}
          </CustomButton>
        </Box>
        } */}
      </Box>
    </Box>
  );
};

const ServicesHeader = ({ image, categoryName }) => {
  const { data } = useCompanyData();
  const { t, displayBanner=true, generalTitleFontSize } = data;
  const variant = generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];

  return (
    <Header image={image}
        height="600px"
        transparencyColor={'#15476db2'}
        bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
        displayBanner={displayBanner}
        titleColor={data.bannerFontColor}
        data={data}
        position="relative"
    >
      <div style={{zIndex:1}}>
        <Box pb={7}>
          <Typography
            variant={variant}
            className={fontSizeCls}
            style={{ color: 'white', fontWeight: 'bold',textTransform:'capitalize' }}
          >
            {categoryName}
          </Typography>
        </Box>

        <CustomBreadCrumbs title={t && t('companyPage.category')} />
      </div>
    </Header>
  );
};

const ServicesList = ({ categories,data, course }) => {
  // const { setPage, count, currentItems } = useMyPagination(categories, 6);
  const displayDescription = data.displayProductDesc !== undefined ? data.displayProductDesc : true;
  const companyId = data.companyData ? data.companyData.companyId : '';
  return (
    <Box py={5} width="90%" m="auto">
      <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
        {categories?.map((item, i) => {
          if(course) {
            return <CourseCard key={i} service={item} {...{displayDescription,companyId}} />
          }
          else{
            return <ServiceCard key={i} service={item} {...{displayDescription,companyId}} />
          }
        })}
      </Box>
      {/* <MyPagination count={count} onChange={setPage} /> */}
    </Box>
  );
};

export default CategoriesList;